import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  DisplayText,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import AddInput from '@nile/banyan/src/Components/Public/AddInput';
import { SVGIcon } from '@superops/super-icons';
import { useIntl } from 'react-intl';
import { isEmpty, noop } from 'lodash';

type ResourceProp = {
  header: string;
  data: Array<string>;
};
type ResourceChildProp = {
  data: Array<string>;
  component: React.ReactNode;
  addOption: Function;
};
type CascaseTemplateProp = {
  resources: ResourceProp;
  resourceChild: ResourceChildProp;
  errors: JSON;
};

const CascadeTemplate = ({
  resources,
  resourceChild,
  errors
}: CascaseTemplateProp) => {
  const intl = useIntl();
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [allData, setAllData] = useState([]);
  const { addOption = noop } = resourceChild || {};

  const handleSelectedItems = (selectedItem) => {
    if (selectedItem?.length > 0) {
      setSelectedItems([selectedItem[selectedItem?.length - 1]]);
      setSelectedData(
        allData?.find((el) => el?.id === selectedItem[selectedItem?.length - 1])
      );
    }
  };

  useEffect(() => {
    if (!isEmpty(resources?.data)) {
      setSelectedItems([resources?.data?.[0]?.id]);
      setSelectedData(
        resources?.data?.find((el) => el?.id === resources?.data?.[0]?.id)
      );
      setAllData(resources?.data);
    }
  }, [resources?.data]);

  return (
    <div className="flex min-height-400 border br8">
      <div className="w300">
        <div className="p1520">
          <DisplayText element="h3" weight="SemiBold">
            {resources?.header || 'Available resources'}
          </DisplayText>
        </div>
        <ResourceList
          selectedItems={selectedItems}
          onSelectionChange={handleSelectedItems}
          items={allData || []}
          renderItem={(item: any) => {
            const { id, value } = item;
            return (
              <ResourceItem id={id}>
                <TextStyle>{value}</TextStyle>
              </ResourceItem>
            );
          }}
        />
      </div>
      <div className="border" />
      <div className="w90percent p1520">
        <DisplayText element="h3" weight="SemiBold">
          {selectedData?.value || (
            <TextStyle>{`${getTranslatedText(
              intl,
              'msp.admin.cascade.subcascade.header'
            )}`}</TextStyle>
          )}
        </DisplayText>
        {resourceChild?.hasOwnProperty('component') ? (
          <>{resourceChild?.component({ parent: selectedData })}</>
        ) : (
          <div className="full-width">
            <div className="mbt20">
              <AddInput
                id="optionInput"
                update={(val) => addOption(val, selectedData)}
                errors={errors || {}}
                placeholder={getTranslatedText(
                  intl,
                  'msp.admin.options.add.placeholder'
                )}
              />
              <div data-qa="cause-list" className="mt10">
                <ResourceList
                  items={resourceChild?.data || []}
                  renderItem={(item: any) => {
                    const { id, name } = item;
                    return (
                      <div className="flex">
                        <TextStyle>{name}</TextStyle>
                        <div className="flex f11">
                          <ButtonGroup spacing="loose">
                            <Button icon={<SVGIcon name="Edit" />} />
                            <Button icon={<SVGIcon name="Delete" />} />
                          </ButtonGroup>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CascadeTemplate;
